<template>
  <div class="search-input">
    <input
      ref="searchInput"
      @input="debouncedInput"
      @focus="isIconShow = false"
      @blur="isIconShow = true"
      :placeholder="placeholder"
      class="search-input__input"
      :type="type"
      @keypress="validate"
    >
    <img
      v-if="isIconShow"
      class="search-input__icon"
      src="@/assets/img/search-icon.svg"
    >
  </div>
</template>

<script>
import InputMask from 'inputmask';

export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      default() {
        return this.$t('searchInput.placeholderSearch');
      },
    },
    mask: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    defaultText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchText: '',
      isIconShow: true,
    };
  },
  mounted() {
    this.maskInput();
    this.searchText = this.defaultText;
  },
  methods: {
    debouncedInput(event) {
      let timeout;
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        this.$emit('search', event.target.value);
      }, 500);
    },
    maskInput() {
      InputMask.extendAliases({
        placeholder: this.placeholder,
      });
      if (this.mask) {
        const inputMask = new InputMask(this.mask, {
          placeholder: '_',
          showMaskOnHover: false,
        });
        inputMask.mask(this.$refs.searchInput);
      }
    },
    validate(event) {
      if (this.type === 'tel') {
        const theEvent = event || window.event;
        let key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        const regex = /[^+\d]/g;
        if (regex.test(key)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) {
            theEvent.preventDefault();
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-input {
    position: relative;
    font-size: 16px;
  }
  .search-input__input {
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    border-radius: 6px;
    border: none;
    outline: none;
    color: var(--text-main-color);
    background: #E6ECF8;
    padding: 0 10px 0 36px;
    transition-duration: .3s;
    transition-property: background-color, box-shadow;
  }
  .search-input__input::placeholder {
    color: #8C93B9;
    font-size: 14px;
    opacity: 0.5;
    font-weight: lighter;
  }
  .search-input__input:focus {
    -webkit-appearance: none;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px rgba(41, 121, 255, 0.3);
    padding: 0 10px;
  }
  .search-input__icon {
    cursor: text;
    position: absolute;
    left: 15px;
    top: 11px;
  }
</style>
